import {ActionEvent, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalGoToDestinationAction} from "./PortalGoToDestinationAction";
import {PortalNamedAction} from "./PortalNamedAction";

export enum PortalActionType {
	None = "none",
	SetLayerState = "setlayerstate",
	GoTo3DView = "goto3dview",
	ResolveURI = "resolveuri",
	HideAnnotation = "hideannotation",
	ResetForm = "resetform",
	ExecuteNamed = "executenamed",
	ImportSchema = "importschema",
	ExecuteJavaScript = "executejavascript",
	GoTo = "goto",
	SubmitForm = "submitform",
	PlaySound = "playsound",
	SetTransition = "settransition",
	GoToThread = "gotothread",
	LaunchApplication = "launchapplication"
}

export class PortalActionEvent extends ActionEvent implements Parameter {
	public type?: PortalActionType;

	constructor(data: any) {
		super(data);

		this.type = FunctionHelper.exists(data?.type) ? data.type : PortalActionType.None;
	}

	public static getTypeDefault(): PortalActionType {
		return PortalActionType.None;
	}

	public static fromJson(data: any): PortalActionEvent {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		if (FunctionHelper.exists(data.goTo)) {
			return PortalGoToDestinationAction.fromJson(data);
		}

		if (FunctionHelper.exists(data.executeNamed)) {
			return PortalNamedAction.fromJson(data);
		}

		let result: PortalActionEvent = super.fromJson(data);
		result.type = FunctionHelper.exists(data?.type) ? data.type : PortalActionType.None;

		return result;
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'type': this.type
		};
	}

	public clone(): PortalActionEvent {
		return PortalActionEvent.fromJson(this.toJson());
	}
}